import { Application } from '@hotwired/stimulus'

const application = Application.start()
const controllers = import.meta.glob('./**/*_controller.js', { eager: true })

for (let path in controllers) {
  let module = controllers[path];
  let name = path
    .match(/.*\.\/(.*)_controller\.js$/)[1]

  application.register(name, module.default);
}

// Controllers from components
const componentsControllers = import.meta.glob('./../../../components/**/controller.js', { eager: true })

for (let path in componentsControllers) {
  let module = componentsControllers[path];
  let name = path
    .match(/.*\/components\/(.+)\/controller\.js$/)[1]

  application.register(name, module.default);
}
